// extracted by mini-css-extract-plugin
export default {"arrow":"CjOdSHy1PD3WTY0B7EcXAw=="};